import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL from "../../BaseURL/baseURL";

export const fetchOTPs = createAsyncThunk(
  "otp/fetchOTPs",
  async ({ mobile, email, whatsappNo, firstName }, { rejectWithValue }) => {
    try {
      const requests = [];
      const requestTypes = [];

      // Prepare the mobile OTP request
      if (mobile) {
        requests.push(
          axios.post(
            `${API_BASE_URL}/Auth/Verify_user_mobile?mobileno=${mobile}`
          )
        );
        requestTypes.push("mobile");
      }

      // Prepare the email OTP request
      if (email) {
        requests.push(
          axios.post(
            `${API_BASE_URL}/Auth/Send_Otp_email?email=${email}&mode=SignIn Verification`
          )
        );
        requestTypes.push("email");
      }

      // Prepare the WhatsApp OTP request
      if (whatsappNo) {
        if (!firstName) {
          throw new Error("First name is required for WhatsApp verification.");
        }

        requests.push(
          axios.post(
            `${API_BASE_URL}/Auth/Send_Whatsapp_Verify_Signup_Otp?whatsappno=${whatsappNo}&name=${firstName}`
          )
        );
        requestTypes.push("whatsapp");
      }

      if (requests.length === 0) {
        throw new Error("No valid fields found to send OTP.");
      }

      // Wait for all API requests to complete
      const responses = await Promise.all(requests);

      const payload = {};
      responses.forEach((response, index) => {
        const field = requestTypes[index];

        if (response.status === 429) {
          throw new Error("OTP already sent. Please wait 30 seconds.");
        }

        if (field === "mobile") {
          // payload.mobileOtp = response.data.Mobile_otp;
          payload.mobileOtp = String(
            JSON.parse(response.data.mobile_otp).result
          );
        }
        if (field === "email") {
          payload.emailOtp = response.data.email_Otp;
        }
        if (field === "whatsapp") {
          payload.whatsappOtp = response.data.whatsapp_Otp;
        }
      });

      return payload;
    } catch (error) {
      if (error.response && error.response.status === 429) {
        return rejectWithValue({
          message:
            error.response.data.message || "Too many requests. Please wait.",
          status: 429,
        });
      }

      return rejectWithValue({
        message: error.message || "An error occurred while sending OTP.",
        status: error.response?.status || 500,
      });
    }
  }
);

const otpSlice = createSlice({
  name: "MobileEmailOtp",
  initialState: {
    mobileOtp: "",
    emailOtp: "",
    whatsappOtp: "",
    status: "idle",
    error: null,
  },
  reducers: {
    clearOTPs: (state) => {
      state.mobileOtp = "";
      state.emailOtp = "";
      state.whatsappOtp = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOTPs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOTPs.fulfilled, (state, action) => {
        state.status = "succeeded";

        // ✅ Update only the fields present in payload
        if ("mobileOtp" in action.payload) {
          state.mobileOtp = action.payload.mobileOtp;
        }
        if ("emailOtp" in action.payload) {
          state.emailOtp = action.payload.emailOtp;
        }
        if ("whatsappOtp" in action.payload) {
          state.whatsappOtp = action.payload.whatsappOtp;
        }
      })
      .addCase(fetchOTPs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearOTPs } = otpSlice.actions;
export default otpSlice.reducer;
